/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";

export default function data(refreshTokens = []) {
  const getToken = (item) => item?.token ?? item?.Token ?? "";
  const getMemberName = (item) => item?.memberName ?? item?.MemberName ?? "";
  const getMemberEmail = (item) => item?.memberEmail ?? item?.MemberEmail ?? "";
  const getExpires = (item) => item?.expires ?? item?.Expires ?? null;
  const getCreated = (item) => item?.created ?? item?.Created ?? null;
  const getRevoked = (item) => item?.revoked ?? item?.Revoked ?? null;
  const getIsActive = (item) => {
    const value = item?.isActive ?? item?.IsActive;
    if (typeof value === "boolean") return value;
    if (typeof value === "number") return value === 1;
    if (typeof value === "string") {
      const normalized = value.trim().toLowerCase();
      return normalized === "true" || normalized === "1" || normalized === "active";
    }
    return false;
  };

  const formatDateTime = (value) => {
    if (!value) return "-";
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return "-";
    return parsed.toLocaleString("en-GB");
  };

  return {
    columns: [
      {
        Header: "member",
        accessor: "memberText",
        align: "left",
        Cell: ({ value }) => (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {value}
          </MDTypography>
        ),
      },
      {
        Header: "token",
        accessor: "tokenText",
        align: "left",
        Cell: ({ value }) => (
          <MDTypography
            variant="caption"
            color="text"
            sx={{ fontFamily: "monospace", wordBreak: "break-all" }}
          >
            {value}
          </MDTypography>
        ),
      },
      {
        Header: "created",
        accessor: "createdText",
        align: "center",
        Cell: ({ value }) => (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {value}
          </MDTypography>
        ),
      },
      {
        Header: "expires",
        accessor: "expiresText",
        align: "center",
        Cell: ({ value }) => (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {value}
          </MDTypography>
        ),
      },
      {
        Header: "revoked",
        accessor: "revokedText",
        align: "center",
        Cell: ({ value }) => (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {value}
          </MDTypography>
        ),
      },
      {
        Header: "status",
        accessor: "statusText",
        align: "center",
        Cell: ({ row }) => row.original.status,
      },
    ],
    rows: refreshTokens.map((item) => {
      const memberName = getMemberName(item);
      const memberEmail = getMemberEmail(item);
      const token = getToken(item);
      const isActive = getIsActive(item);

      return {
        memberText: memberEmail ? `${memberName} (${memberEmail})` : memberName || "-",
        tokenText: token || "-",
        createdText: formatDateTime(getCreated(item)),
        expiresText: formatDateTime(getExpires(item)),
        revokedText: formatDateTime(getRevoked(item)),
        statusText: isActive ? "active" : "inactive",
        status: (
          <MDBadge
            badgeContent={isActive ? "active" : "inactive"}
            color={isActive ? "success" : "secondary"}
            variant="gradient"
            size="sm"
          />
        ),
      };
    }),
  };
}
